// extracted by mini-css-extract-plugin
export default {"IMAGE_SIZE":"26px","imageSize":"26px","container":"Gka3kA","image":"mP9yec"};